import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useSessionStorage } from "usehooks-ts";

import { useAuth } from "$/lib/providers/AuthProvider";
import { ROUTES } from "$/lib/utils/constants/routes.constants";
import { restApiClient } from "$/lib/utils/restApiClient";
import { useProfileProvider } from "$/routes/_user-layout/profile/-features/providers/ProfileProvider";

export async function logoutApi() {
  return restApiClient.post("/auth/logout");
}

export function useLogout() {
  const currentYear = new Date().getFullYear();
  const defaultFilters = {
    page: 1,
    modes: [],
    amount: null,
    endDate: new Date(`${currentYear}-12-31`),
    startDate: new Date(`${currentYear}-01-01`),
    maxAmount: null,
    minAmount: null,
    searchText: "",
    categories: [],
    onlyUncategorized: false,
    year: currentYear,
  };
  const [, , clearManagementYear] = useSessionStorage(
    "management-year",
    currentYear,
  );
  const [, setShowEstimateData] = useSessionStorage(
    "financial-report-show-estimate-data",
    false,
  );
  const [_, clearFilters] = useSessionStorage("filters", defaultFilters);
  const queryClient = useQueryClient();
  const { clearUser } = useAuth();
  const { resetProfile } = useProfileProvider();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: logoutApi,
    onSettled: () => {
      clearUser();
      clearManagementYear();
      clearFilters(defaultFilters);
      resetProfile();
      queryClient.clear();
      setShowEstimateData(false);
      navigate({ to: ROUTES.LOGIN, replace: true });
    },
  });
}
